/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/19/19
 * Time: 5:34 PM
 */

import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Fade, Row} from "reactstrap";
import Chart_VisitorCount_Bar from '../../../const/ChartFrame_VisitorCount_Bar'
import ReactHighChartBasicArea from "react-highcharts/ReactHighcharts.src";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import * as common from "../../../const/Common/CommonFunc";
import Download from "../../../components/Button/DownloadbleButton";
import {Button, Dropdown, Icon} from 'semantic-ui-react'
import building_icon from "../../../assets/img/recept_checkin/building.svg";
import './VisitorCount.css'
import { DatePicker } from 'antd';
import moment from "moment";
import apiConfig from "../../../axios/axios_api_services";

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends Component {
  state = {
    visitor_list: [],
    state:"All Buildings",
    date: moment().format('YYYY-MM-DD')
  };

  getAllVisitorsCount = (date) => {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    // Get All Current Check In User List Of Corporate
    let url = ``;
    if(this.props.usr_obj.userRoles === "RECEPTION" || this.props.usr_obj.userRoles === "EXTERNAL_RECEPTION"){
      url = apiConfig.CORPORATE_VISITORS_COUNT(coperateId);
    }else{
      url = apiConfig.CORPORATE_VISITORS_COUNT_BY_DATE({corporateId:coperateId,date:date});
    }

    axios.get(url, {headers: headers})
      .then(response => {
        let data = [];

        this.props.spinnerHandler(false);
        let data_ = response.data;

        if (data_.length !== 0) {
          data_.map((element, index) => {
            const obj = {
              name: element.name,
              data: element.visitorCount,
            };
            data.push(obj)
          })
        }
        this.setState({
          visitor_list: data,
          state:"All Buildings"
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllVisitorsCount(date);
        } else {
          this.props.spinnerHandler(false)
        }
      });
  };

  getVisitorsCountUsingSelectedBuilding = (id) => {
    this.props.spinnerHandler(true);
    let state = "";
    this.props.all_building_list.map((element, index) => {
      if(element.buildingId === id){
        state = element.name;
      }
    });

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    let url = ``;
    if(this.props.usr_obj.userRoles === "RECEPTION" || this.props.usr_obj.userRoles === "EXTERNAL_RECEPTION"){
      url = apiConfig.CORPORATE_VISITORS_COUNT_IN_BUILDING({corporateId:coperateId,buildingId:id});
    }else{
      url = apiConfig.CORPORATE_VISITORS_COUNT_IN_BUILDING_BY_DATE({corporateId:coperateId,buildingId:id,date:this.state.date});
    }

    axios.get(url, {headers: headers})
      .then(response => {
        let data = [];

        this.props.spinnerHandler(false);
        let data_ = response.data;

        if (data_.length !== 0) {
          data_.map((element, index) => {
            const obj = {
              name: element.description,
              data: element.visitorCount,
              color: element.floor_colour
            };
            data.push(obj)
          })
        }

        this.setState({
          visitor_list: data,
          state:state
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllVisitorsCount(id);
        } else {
          this.props.spinnerHandler(false)
        }
      });
  };

  componentDidMount() {
    this.props.callAllBuildings(this.props.usr_obj);
    if(this.props.usr_obj.userRoles === "RECEPTION"){
      this.getAllVisitorsCount();
    }else{
      this.getAllVisitorsCount(moment().format('YYYY-MM-DD'));
    }
  }

  buildingChanger = (e,{value}) => {
    if(value !== ""){
      this.getVisitorsCountUsingSelectedBuilding(value);
    }
  };

  dateOnChange = (date, dateString) => {
    if(dateString !== ""){
      this.setState({
        date:dateString
      });
      this.getAllVisitorsCount(dateString)
    }
  };

  render() {
    let config_data_1 = Chart_VisitorCount_Bar;

    config_data_1.series = this.state.visitor_list;
    config_data_1.xAxis.categories = this.props.visitor_times_list_graph;

    let all_building_list = this.props.all_building_list;
    const building_options = [];

    if (all_building_list.length !== 0) {
      all_building_list.map((element, index) => {
        building_options.push({
          key: index,
          text: element.name,
          value: element.buildingId,
          image: {avatar: true, src: building_icon},
        })
      })
    }

    let timerange = this.props.visitor_times_list_graph;
    let download_option = [];
    if(this.state.visitor_list.length !== 0){
      this.state.visitor_list.map((visitor,index)=>{
        // let array = [];
        // visitor.data.map((data,index)=>{
        //   const obj = {
        //     timeRange: timerange[index],
        //     value: data
        //   };
        //   array.push(obj);
        // });
        download_option.push({
          ["7-8"]:  visitor.data[0],
          ["8-9"]:  visitor.data[1],
          ["9-10"]:  visitor.data[2],
          ["10-11"]:  visitor.data[3],
          ["11-12"]:  visitor.data[4],
          ["12-13"]:  visitor.data[5],
          ["13-14"]:  visitor.data[6],
          ["14-15"]:  visitor.data[7],
          ["15-16"]:  visitor.data[8],
          ["16-17"]:  visitor.data[9],
          ["17-18"]:  visitor.data[10],
          ["18-19"]:  visitor.data[11],
          ["19-7"]:  visitor.data[12],
          name: visitor.name
        })
      })
    }
    return (
      <div>
        <div>
          {/*{*/}
          {/*this.props.usr_obj.userRoles === "RECEPTION" ?*/}
          {/*<h4 className={"route-name-style"}>{this.props.route_name}</h4>*/}
          {/*: <h4 className={"route-none-style"}/>*/}
          {/*}*/}
          <Row style={{padding:'1% 0px'}}>
            <Col xs={6} lg={2} md={3} style={{paddingRight:'0px'}}>
              <Button animated color="grey" className={"building-count-btn"} onClick={()=>this.getAllVisitorsCount(this.state.date)}>
                <Button.Content visible>View all buildings&nbsp;&nbsp;
                  <Icon name='building'/>
                </Button.Content>
                <Button.Content hidden>
                  View all buildings&nbsp;&nbsp;
                  <Icon name='arrow down'/>
                </Button.Content>
              </Button>
            </Col>
            <Col xs={6} lg={3} md={3}>
              <Dropdown
                placeholder='Select building'
                fluid
                search
                selection
                clearable
                options={building_options}
                onChange={this.buildingChanger}
              />
            </Col>
            {
              this.props.usr_obj.userRoles !== "RECEPTION" && this.props.usr_obj.userRoles !== "EXTERNAL_RECEPTION" ?
                <Col xs={6} lg={3} md={3}>
                  <DatePicker
                    allowClear={false}
                    disabledDate={disabledDate}
                    className={"corp-admin-date"}
                    onChange={this.dateOnChange}
                    defaultValue={moment().subtract(0, "days")}
                  />
                </Col>:null
            }
          </Row>
        </div>
        <Row>
          {/* area chart */}
          <Col xs="12" lg={"12"} md={"12"}>
            <Fade>
              <Card>
                <CardHeader>
                  {"Visitor Count - "+this.state.state}
                  <Download data={download_option} filename={"totalvisitors.csv"}/>
                </CardHeader>
                <Collapse isOpen={true} id="collapseExample">
                  <CardBody>
                    <div>
                      <ReactHighChartBasicArea config={config_data_1}/>
                    </div>
                  </CardBody>
                </Collapse>
              </Card>
            </Fade>
          </Col>

        </Row>
      </div>
    );
  }
}

// reception_VisitorCountReducer

const mapStateToProps = (state) => ({
  visitor_count_list: state.reception_VisitorCountReducer.visitor_count_list,
  visitor_count_list_graph: state.reception_VisitorCountReducer.visitor_count_list_graph,
  visitor_times_list_graph: state.reception_VisitorCountReducer.visitor_times_list_graph,

  usr_obj: state.userReducer.user,
  all_building_list: state.reception_SheduleMeetingReducer.all_building_list, // all buildings
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate
    callAllWifiPackages: (data) => dispatch(actionCreator.callAllWifiPackages(data)), // Get All Wifi Packges Of Corporate

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // reception meeting shedule handler
    receptionAddCustomVisitorsHandler: (data) => dispatch(actionCreator.receptionAddCustomVisitorsHandler(data)),

    // all floors
    receptionAllFloorHandler: (data) => dispatch(actionCreator.receptionAllFloorHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
